<script>
import CabecalhoRelatorio from './CabecalhoRelatorio.vue';
import { datepicker } from 'vue-strap';
import transparenciaServico from '../../servico';
import Carregando from '~componentes/Carregando.vue';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  components: { CabecalhoRelatorio, datepicker, transparenciaServico, XLSX, saveAs, Carregando },
  data() {
    return {
      dataInicio: '',
      dataFim: '',
      relatorio: [],
      carregando: false,
      dataInicioFormatada: '',
      dataFimFormatada: '',
      titulo: "Relatorio de lançamentos financeiros de todos os projetos",
      diferencaDias: 0,
      LIMITEDIAS: 180,
    }
  },
  methods: {
    formatarNumero(valor) {
      return this.$options.filters.formatarNumero(valor);
    },
    exportarExcel() {
      const data = [
        [this.titulo],
        [],
        ["Nome Projeto", "Data", "CPF/CNPJ", "Rubrica", "Histórico", "Complemento", "Documento", "Valor (R$)"],
      ];

      this.relatorio.forEach(item => {
        data.push([
          item.nomeProjeto,
          this.$options.filters.formatarData(item.data),
          item.cpfCnpj,
          item.nomeRubrica || '---',
          item.historico,
          item.complemento,
          item.documento || '---',
          item.creditoDebito === 1 ? (this.formatarNumero(item.valor)) : (this.formatarNumero(-item.valor)),
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(data);

      const nomeArquivo = "relatorio_todos_projetos"

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, nomeArquivo);

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${nomeArquivo}.xlsx`);
    },
    imprimirPagina() {
      window.print();
    },
    voltar() {
      this.$router.push({ name: 'transparencia.projetos', query: this.$route.query, params: { id: this.$route.params.id } });
    },
    limparFiltros() {
      this.dataInicio = '';
      this.dataFim = '';
    },
    exibirMensagemRelatorioVazio() {
      this.$swal('', 'Nenhum resultado encontrado.', 'info');
    },
    formatarDatas() {
      this.dataInicioFormatada = moment(this.dataInicio, 'DD/MM/YYYY');
      this.dataFimFormatada = moment(this.dataFim, 'DD/MM/YYYY');
    },
    calcularDiferencaDias() {
      this.diferencaDias = this.dataFimFormatada.diff(this.dataInicioFormatada, 'days');
    },
    verificarData() {
      if (!this.dataInicio || !this.dataFim) {
        this.$swal('', 'Preencha as datas do filtro.', 'error');
        return false;
      }

      this.formatarDatas();

      if (!this.dataInicioFormatada.isSameOrBefore(this.dataFimFormatada)) {
        this.$swal('', 'Data inicial deve ser menor ou igual a data final.', 'error');
        return false;
      }

      this.calcularDiferencaDias();
      if (this.diferencaDias > this.LIMITEDIAS) {
        this.$swal('', "Período máximo de " +  this.LIMITEDIAS  + " dias entre as datas de início e fim do filtro.", 'error');
        return false;
      }

      return true;
    },
    filtrar() {
      if (!this.verificarData()) {
        return
      }

      this.carregando = true;
      this.relatorio = [];

      return transparenciaServico.relatorioLancamentosTodosProjetos(this.dataInicio, this.dataFim)
        .then(relatorio => {
          this.carregando = false;

          if (relatorio.length === 0) {
            this.exibirMensagemRelatorioVazio();
          } else {
            this.relatorio = relatorio;
          }
        })
        .catch(() => {
          this.$swal('', 'Ocorreu um erro ao exibir o relatório, tente novamente.', 'error');
        });
    },
  },
  mounted() {
    this.dataInicio = moment().subtract(this.LIMITEDIAS, 'days').calendar();
    this.dataFim = moment().format('DD/MM/YYYY');
    this.filtrar();
  },
  watch: {
    dataInicio() {
      this.formatarDatas();
      this.calcularDiferencaDias();
    },
    dataFim() {
      this.formatarDatas();
      this.calcularDiferencaDias();
    }
  }
}
</script>

<template>
  <div>

    <cabecalho-relatorio :titulo=this.titulo nomeProjeto="" borda=""></cabecalho-relatorio>

    <div class="row hidden-print" style="padding-left:20px">

      <div class="col-md-10 flex-container" style="justify-content:start; padding-left:15px">
        <h2><b>{{ this.titulo }}</b></h2>
      </div>

      <div class="col-md-2 flex-container" style="justify-content:end; gap:10px; padding-top: 18px;">

        <button class="btn btn-primary" @click="exportarExcel">
          <i class="fa fa-file-excel-o"></i> Excel
        </button>

        <button class="btn btn-primary" @click="imprimirPagina">
          <i class="fa fa-file-pdf-o"></i> PDF
        </button>

        <button class="btn btn-primary" @click="voltar">
          <i class="fa fa-arrow-left"></i> Voltar
        </button>

      </div>

    </div>

    <div class="row hidden-print" style="padding-left:20px; margin-bottom: 20px;">
      <div class="col-lg-12">
        <label class="control-label">Período de pagamento</label>
      </div>

      <div class="col-xs-2" style="padding-right: 0px;">
        <div class="form-group" style="margin-bottom: 2px;">
          <label class="control-label">De:</label>

          <datepicker v-model="dataInicio" format="dd/MM/yyyy" placeholder="  /  /     " lang="pt-BR"
            data-vv-name="dataInicio" data-vv-as="data inicial" v-validate="'date_format:dd/MM/yyyy'"></datepicker>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group" style="margin-bottom: 2px;">
          <label class="control-label">Até:</label>

          <datepicker v-model="dataFim" format="dd/MM/yyyy" placeholder="  /  /     " lang="pt-BR"
            data-vv-name="dataFim" data-vv-as="data fim" v-validate="'date_format:dd/MM/yyyy'"></datepicker>
        </div>
      </div>

      <div class="col-xs-3">

        <label class="control-label" style="visibility: hidden; margin-bottom: 5px;">filtrar</label>

        <div class="row">
          <button class="btn btn-primary" style="margin-right: 5px;" @click="filtrar">
            Filtrar
          </button>

          <button class="btn btn-primary" @click="limparFiltros" :disabled="!dataInicio && !dataFim">
            Limpar Filtros
          </button>
        </div>

      </div>

      <div class="col-lg-12">
        <label :class="[this.diferencaDias > this.LIMITEDIAS && 'text-danger']"
          style="margin-bottom: 0px; margin-left: 1px;">Período máximo de {{ this.LIMITEDIAS }} dias entre as datas de
          início e fim do
          filtro.</label>
      </div>

    </div>

    <Carregando v-if="carregando"></Carregando>

    <div class="ibox float-e-margins">
      <div class="ibox-content">

        <div class="row text-right" style="padding-right:18px; padding-bottom: 15px;" v-if="!carregando">
          Total: {{ this.relatorio.length }} registro(s)
        </div>

        <div class="table-responsive" v-if="!carregando">

          <table class="table relatorio table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>Nome Projeto</th>
                <th>Data</th>
                <th>CPF/CNPJ</th>
                <th>Rubrica</th>
                <th>Histórico</th>
                <th>Complemento</th>
                <th>Documento</th>
                <th>Valor&nbsp;(R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="lancamento, key in relatorio" :key="key">
                <td>{{ lancamento.nomeProjeto }}</td>
                <td>{{ lancamento.data | formatarData }}</td>
                <td>{{ lancamento.cpfCnpj }}</td>
                <td>{{ lancamento.nomeRubrica || '---' }}</td>
                <td>{{ lancamento.historico }}</td>
                <td>{{ lancamento.complemento }}</td>
                <td>{{ lancamento.documento || '---' }}</td>
                <td :class="['text-right', lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']">{{
                  lancamento.valor | formatarNumero }}</td>
              </tr>
              <tr v-if="relatorio.length === 0">
                <td colspan="8" class="text-center">Não há dados.</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/RelatorioLancamentosTodosProjetos.vue